import styled from 'styled-components';
import DocumentsBillingData from './DocumentsBillingData';
import { colorSchema, media } from 'utils/style';

export default styled(DocumentsBillingData)`
  background: ${colorSchema('white')};
  border-top: 1px solid ${colorSchema('grey700')};
  height: auto;
  min-height: 100%;
  margin: 0 -1rem;
  padding: 0 1rem;

  ${media.greaterThan('tablet')`
    border: 0;
    margin: 0;
    padding: 0;
  `}

  .documents-billing-data {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    flex-direction: column;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
      max-width: 1128px;
      margin: 0 auto;
    `}

    &__header {
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        grid-column: 1 / span 12;
        padding: 0 2rem;
      `}
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: normal;
      margin: 2.3rem 0 1.6rem 0;

      ${media.greaterThan('tablet')`
        border-bottom: 1px solid ${colorSchema('grey200')};
        padding-bottom: .6rem;
        margin: 2.3rem 0 1.6rem 0;
      `}
    }

    &__container {
      grid-column: 1 / span 4;
      grid-row: 2;
      padding: 0 1.6rem;
      margin-bottom: 2rem;

      ${media.greaterThan('tablet')`
        grid-column: 1 / span 12;
        padding: 0 2rem;
        display: grid;
        row-gap: 16px;
        grid-template-columns: repeat(12, 1fr);
        column-gap: 50px;
        margin-bottom: 3rem;
      `}
    }

    &__loading,
    &__error {
      display: flex;
      padding: 2rem 0;
      height: 100vh;
      justify-content: center;
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        height: 100vh;
        grid-column: 1 / span 12;
      `}
    }

    &__tooltip-container {
      display: flex;
      flex-direction: column;

      ${media.greaterThan('tablet')`
        grid-column: 5 / span 3;
        grid-row: 5;
        margin-top: 7.3rem;
      `}
    }

    &__tooltip-link {
      color: ${colorSchema('grey900')};
      font-size: 1.2rem;
      font-weight: 500;
      text-decoration: underline;
      margin-bottom: 0.8rem;

      svg {
        fill: ${colorSchema('grey900')};
        height: 8px;
        transform: rotate(90deg);
        width: 8px;
      }

      &--open {
        svg {
          transform: rotate(-90deg);
        }
      }
    }

    &__tooltip-text {
      color: ${colorSchema('grey700')};
      font-size: 1.2rem;
      font-weight: normal;
    }

    &__footer {
      ${media.greaterThan('tablet')`
        grid-column: 1 / span 12;
        display: flex;
        justify-content: center;
      `}
    }

    &__submit {
      ${media.greaterThan('tablet')`
        width: 320px;

        button {
          width: 100%;
        }
      `}
    }

    &__question-help {
      color: ${colorSchema('grey700')};
      font-size: 1.2rem;
      margin-top: 0.8rem;
    }

    &__error {
      display: flex;
      padding: 0.8rem 1.6rem;
      border: 1px solid ${colorSchema('error700')};
      background: ${colorSchema('error100')};
      font-weight: 500;
      height: auto;
      color: ${colorSchema('grey900')};
      border-radius: 4px;
      margin-top: 1.6rem;
      font-size: 1.4rem;
    }

    &__question {
      &--select {
        input {
          height: auto;
        }
      }

      &--country {
        ${media.greaterThan('tablet')`
          grid-column: 1 / span 4;
        `}
      }
    }

    &__warning {
      margin-bottom: 3.2rem;
      &--text {
        color: ${colorSchema('grey700')};
        font-size: 1.4rem;
        font-weight: normal;
      }

      &--icon {
        margin-right: 0.8rem;
        svg {
          fill: ${colorSchema('grey700')};
        }
      }
    }
  }
`;
